<div class="legend-container">
	<h4 class="legend-header">Legenda</h4>
	<div class="legend-content mx-3">
		@for (item of legendItems; track item) {
			<div class="row">
				@for (element of item | keyvalue; track element.key) {
					<div class="col d-flex align-items-center justify-content-start legend-item">
						<div [class]="element.value.className" class="legend-square me-2"></div>
						{{ element.value.label }}
					</div>
				}
			</div>
		}
	</div>
</div>
